import Vue from 'vue';
import Rahoituslaskimet_v2 from './Rahoituslaskimet_v2';
export const eventBus = new Vue();
var v = new Vue({
    el: '#vra',
    data: function () {
        return {
            autonhinta: (<any>window).autonhinta,
            autontunniste: (<any>window).autontunniste,
            showKampanjakoodi: false,
            ytunnus: (<any>window).ytunnus,
            kategoria: (<any>window).kategoria
        }
    },
    template: `<div>
                <Rahoituslaskimet_v2 :autonhinta="autonhinta" :autontunniste="autontunniste" :ytunnus="ytunnus" :kategoria="kategoria" />
               </div>`,
    components: {
        Rahoituslaskimet_v2
    }
});
